import { slideToggle } from "slide-animator";

var hsAccordionItems = document.querySelectorAll(".js-hs-accordion-item");

hsAccordionItems.forEach(function (item) {
  var button = item.querySelector(".js-hs-accordion-button");
  var content = item.querySelector(".js-hs-accordion-content");

  if (button && content) {
    button.addEventListener("click", function () {
      var isExpanded = item.classList.contains("active");
      button.setAttribute("aria-expanded", !isExpanded);
      slideToggle(content);
      item.classList.toggle("active");
    });
  }
});
